"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textStatus = exports.textButton = void 0;
var textButton = exports.textButton = {
  success: 'Подписаться снова',
  failed: 'Попробовать еще раз',
  idle: 'Отписаться от пуш-уведомлений\nэтой подписки'
};
var textStatus = exports.textStatus = {
  success: 'Вы отписаны от пуш-уведомлений этой подписки',
  failed: 'Что-то пошло не так. Не получилось отписаться от пуш-уведомлений'
};